import Topbar from "../components/Topbar";
import { useQuery } from "@tanstack/react-query";
import { api, endpoints } from "../lib/api";
import { MapPin, Clock, Users, DoorOpen, MessageSquare, Crown } from "lucide-react";

export default function Settings() {
  const { data: pros = [] } = useQuery({ queryKey: ["professionals"], queryFn: () => api.get(endpoints.professionals).then((r) => r.data) });
  const { data: rooms = [] } = useQuery({ queryKey: ["rooms"], queryFn: () => api.get(endpoints.rooms).then((r) => r.data) });
  const { data: plans = [] } = useQuery({ queryKey: ["plans"], queryFn: () => api.get(endpoints.plans).then((r) => r.data) });

  return (
    <div>
      <Topbar title="Ajustes" subtitle="Datos del centro, equipo, salas y personalización." />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <Section icon={MapPin} title="Datos del centro">
          <Row label="Nombre">LAKA Club Beauty · Madrid</Row>
          <Row label="Dirección">Calle Serrano, 88 · 28006 Madrid</Row>
          <Row label="Teléfono">+34 910 000 000</Row>
          <Row label="Email">hola@lakaclubbeauty.com</Row>
        </Section>

        <Section icon={Clock} title="Horarios">
          <Row label="Lun — Vie">10:00 — 21:00</Row>
          <Row label="Sábado">10:00 — 18:00</Row>
          <Row label="Domingo">Cerrado</Row>
        </Section>

        <Section icon={Users} title="Profesionales">
          <div className="flex flex-wrap gap-2">
            {pros.map((p) => (
              <span key={p} className="text-xs px-3 py-1 rounded-full" style={{ backgroundColor: "#F5EFE7" }}>{p}</span>
            ))}
          </div>
        </Section>

        <Section icon={DoorOpen} title="Salas">
          <div className="flex flex-wrap gap-2">
            {rooms.map((r) => (
              <span key={r} className="text-xs px-3 py-1 rounded-full" style={{ backgroundColor: "#F5EFE7" }}>{r}</span>
            ))}
          </div>
        </Section>

        <Section icon={Crown} title="Configuración de planes" wide>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {plans.map((p) => (
              <div key={p.id} className="border laka-hairline rounded-md p-3">
                <div className="text-xs" style={{ color: "var(--laka-text)" }}>{p.name}</div>
                <div className="font-display text-2xl mt-1" style={{ color: "#D6B36A" }}>{p.price_monthly}€</div>
                <div className="text-[10px]" style={{ color: "var(--laka-text)" }}>{p.active_clients} suscriptoras</div>
              </div>
            ))}
          </div>
        </Section>

        <Section icon={MessageSquare} title="Personalización de mensajes" wide>
          <p className="text-sm" style={{ color: "var(--laka-text)" }}>
            Los mensajes recomendados de la sección Marketing son plantillas editables. En próximas versiones podrás
            personalizar tono, firma y variables dinámicas por segmento y canal.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ icon: Icon, title, children, wide }) {
  return (
    <div className={`laka-card p-6 ${wide ? "md:col-span-2" : ""}`}>
      <div className="flex items-center gap-2 mb-4">
        <Icon size={16} strokeWidth={1.25} style={{ color: "#D6B36A" }} />
        <h3 className="font-display text-xl">{title}</h3>
      </div>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div className="flex justify-between text-sm py-1.5 border-b laka-hairline last:border-0">
      <span style={{ color: "var(--laka-text)" }}>{label}</span>
      <span className="font-medium">{children}</span>
    </div>
  );
}
